import { Trans } from '@lingui/react'
import { type VFC } from 'react'

import Modal from 'views/components/molecules/Modal'
import { useMaxDosageValues } from 'views/components/organisms/Cart/hooks/useMaxDosageValues'

import { COLLECTIVE_ORDER_MODAL } from './const'

interface CollectiveOrderModalProps {
  open?: boolean
}

const CollectiveOrderModal: VFC<CollectiveOrderModalProps> = ({
  open = false,
}) => {
  const { isForMaxDosageLoggedInUser } = useMaxDosageValues()
  return (
    <Modal
      id={COLLECTIVE_ORDER_MODAL}
      title={
        <Trans id={'cart.notification.maxDosage.cartInfoBox.modal.heading'} />
      }
      size="medium"
      isClientSideControlled
      open={open}
    >
      {isForMaxDosageLoggedInUser ? (
        <Trans
          id="cart.notification.maxDosageWithCph.cartInfoBox.modal.body"
          components={{
            br: <br />,
            ul: <ul />,
            li: <li />,
          }}
        />
      ) : (
        <Trans
          id="cart.notification.maxDosage.cartInfoBox.modal.body_rebranding"
          components={{
            br: <br />,
            ul: <ul />,
            li: <li />,
          }}
        />
      )}
    </Modal>
  )
}

export default CollectiveOrderModal
